import { render } from "./Fipe.vue?vue&type=template&id=cd357b06&scoped=true"
import script from "./Fipe.vue?vue&type=script&lang=js"
export * from "./Fipe.vue?vue&type=script&lang=js"

import "./Fipe.vue?vue&type=style&index=0&id=cd357b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd357b06"]])

export default __exports__